<div class="cafi-welcome__backdrop" *ngIf="visible" (click)="dismiss()">
  <div class="cafi-welcome" (click)="$event.stopPropagation()">
    <!-- Close / Skip button -->
    <button class="cafi-welcome__skip" (click)="dismiss()">Omitir</button>

    <!-- Illustration -->
    <div class="cafi-welcome__hero">
      <img src="assets/cafler-avatar.svg" alt="CAFI" class="cafi-welcome__avatar" />
      <div class="cafi-welcome__badge">NUEVO</div>
    </div>

    <!-- Content -->
    <h2 class="cafi-welcome__title">Conoce a CAFI</h2>
    <p class="cafi-welcome__subtitle">Tu nuevo asistente inteligente de taller</p>

    <div class="cafi-welcome__features">
      <div class="cafi-welcome__feature">
        <span class="cafi-welcome__feature-icon">💬</span>
        <div>
          <strong>Pregunta lo que quieras</strong>
          <p>Ordenes, clientes, stock, citas... en lenguaje natural</p>
        </div>
      </div>
      <div class="cafi-welcome__feature">
        <span class="cafi-welcome__feature-icon">📊</span>
        <div>
          <strong>Informes al instante</strong>
          <p>KPIs, briefing diario y coaching de negocio</p>
        </div>
      </div>
      <div class="cafi-welcome__feature">
        <span class="cafi-welcome__feature-icon">📷</span>
        <div>
          <strong>Fotos inteligentes</strong>
          <p>Sube un DNI, neumatico o matricula y CAFI lo interpreta</p>
        </div>
      </div>
      <div class="cafi-welcome__feature">
        <span class="cafi-welcome__feature-icon">🛒</span>
        <div>
          <strong>Compra desde el chat</strong>
          <p>Busca neumaticos y pide directamente al proveedor</p>
        </div>
      </div>
    </div>

    <!-- CTA -->
    <button class="cafi-welcome__cta" type="button" (click)="goToChat()">
      Probar CAFI ahora
    </button>
    <button class="cafi-welcome__later" (click)="dismiss()">Mas tarde</button>
  </div>
</div>
